import { Box } from '@mantine/core'
import React, { useState, type PropsWithChildren } from 'react'

import { type UNSAFE_any } from '@flecto/types'

import classes from './styles.module.css'

type WrapperBodyProps = PropsWithChildren

function useScrollPosition() {
  const [scrollTop, setScrollTop] = useState(0)
  const [scrollBottom, setScrollBottom] = useState(0)

  const onScroll = (event: UNSAFE_any) => {
    const element = event.target

    setScrollTop(event.target.scrollTop)
    setScrollBottom(
      Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop)
    )
  }

  return {
    scrollTop,
    scrollBottom,
    onScroll,
  }
}

export function WrapperBody({ children }: WrapperBodyProps) {
  const { scrollTop, scrollBottom, onScroll } = useScrollPosition()

  return (
    <Box
      onScroll={onScroll}
      className={classes.wrapperBody}
      style={{
        transition: 'all ease-in-out 100ms',
        borderTop:
          scrollTop > 0
            ? 'solid 1px var(--mantine-color-gray-2)'
            : 'solid 1px transparent',
        borderBottom:
          scrollBottom > 0
            ? 'solid 1px var(--mantine-color-gray-2)'
            : 'solid 1px transparent',
      }}
    >
      {children}
    </Box>
  )
}

WrapperBody.displayName = 'ModalWrapperBody'
